import React, { useState } from 'react';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill styles
import ComanServices from '../../../services/ComanServices';

function AddStock() {
  const [formData, setFormData] = useState({
    stock:'',
    title: '',
    description: '', // Will now handle HTML content
    file: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  // Handle change for the rich text editor (description field)
  const handleDescriptionChange = (value) => {
    setFormData({ ...formData, description: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Form data for file upload
    const data = new FormData();
    data.append('stock', formData.stock);
    data.append('title', formData.title);
    data.append('description', formData.description); // HTML content
    data.append('images', formData.file);

    try {
      const response = await ComanServices.addStock(data);
      console.log('stock added successfully', response.data);
      alert('stock added successfully!');
    } catch (error) {
      console.error('There was an error adding the stock!', error);
      alert('Failed to add stock. Please try again.');
    }
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Stock Add</h2>
        <div className="container-box-top-header-right">
          <a className="list-banner-btn" href="/admin/stock">
            Stocks List
          </a>
        </div>
      </div>
      <div className="container-box px-5">
        <div className="container-box-inner">
          <div className="page-details">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Title</label>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>Stock</label>
                    <input
                      type="text"
                      name="stock"
                      value={formData.stock}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-field">
                    <label>
                      Upload<span className="red">*</span>
                    </label>
                    <input
                      type="file"
                      name="file"
                      onChange={handleFileChange}
                      className="form-control"
                      multiple
                      required
                    />
                    <p>
                      <span>
                        Drop an image or Paste URL (upto resolution 1,500 x 1,500 px),
                      </span>{' '}
                      Supported formats: png, jpeg, jpg, webp
                    </p>
                    <div className="file-preview text-center">
                      <img
                        id="uploadFile"
                        src={formData.file ? URL.createObjectURL(formData.file) : 'img/placeholder-img.png'}
                        alt="your image"
                        style={{ maxWidth: '150px', maxHeight: '150px' }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="input-field">
                    <label>Description</label>
                    <ReactQuill
                      value={formData.description}
                      onChange={handleDescriptionChange}
                      theme="snow"
                      className="form-control"
                      required
                    />
                  </div>
                </div>
              </div>
              <button type="submit" className="submit-green-btn">
                SUBMIT
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddStock;
